import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const FilePreview = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M10.25 22a.75.75 0 0 0 0-1.5zm8.25-11.25a.75.75 0 0 0 1.5 0zm1.461 11.272a.75.75 0 1 0 1.078-1.044zM8.75 6a.75.75 0 0 0 0 1.5zm6.5 1.5a.75.75 0 0 0 0-1.5zM8.75 10a.75.75 0 0 0 0 1.5zm3.5 1.5a.75.75 0 0 0 0-1.5zM5.5 19.25V4.75H4v14.5zM6.75 3.5h10.5V2H6.75zm3.5 17h-3.5V22h3.5zM18.5 4.75v6H20v-6zM17.25 3.5c.69 0 1.25.56 1.25 1.25H20A2.75 2.75 0 0 0 17.25 2zM5.5 4.75c0-.69.56-1.25 1.25-1.25V2A2.75 2.75 0 0 0 4 4.75zM4 19.25A2.75 2.75 0 0 0 6.75 22v-1.5c-.69 0-1.25-.56-1.25-1.25zm12.5 1.25a3 3 0 0 1-3-3H12a4.5 4.5 0 0 0 4.5 4.5zm-3-3a3 3 0 0 1 3-3V13a4.5 4.5 0 0 0-4.5 4.5zm3-3a3 3 0 0 1 3 3H21a4.5 4.5 0 0 0-4.5-4.5zm3 3c0 .82-.328 1.562-.862 2.104l1.07 1.052A4.5 4.5 0 0 0 21 17.5zm-.862 2.104a3 3 0 0 1-2.138.896V22a4.5 4.5 0 0 0 3.208-1.344zm2.4 1.374-1.326-1.37-1.078 1.044 1.327 1.37zM8.75 7.5h6.5V6h-6.5zm0 4h3.5V10h-3.5z'
        fill='currentColor'
      />
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4 3.75C4 2.784 4.784 2 5.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.876A6 6 0 0 0 12.531 22H5.75A1.75 1.75 0 0 1 4 20.25zm3 2A.75.75 0 0 1 7.75 5h6.5a.75.75 0 0 1 0 1.5h-6.5A.75.75 0 0 1 7 5.75m0 4A.75.75 0 0 1 7.75 9h3.5a.75.75 0 0 1 0 1.5h-3.5A.75.75 0 0 1 7 9.75'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M16.5 13a4.5 4.5 0 1 0 2.623 8.157l.838.865a.75.75 0 1 0 1.078-1.044l-.86-.887A4.5 4.5 0 0 0 16.5 13m-3 4.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
